<p class="font-allRoundGothic text-4xl mb-2 mt-6">{{ 'technical_error_occured' | translate }}</p>
<div class="border-2 border-black w-10"></div>
<p class="font-bold mt-8 mb-8">{{ 'sorry_page_cant_be_displayed' | translate }}</p>
<button
  class="bg-primary font-bold text-secondary m-auto flex-1 pt-3 pb-3 rounded-full mb-6 w-full"
  (click)="continue()"
>
  {{ 'continue_my_request' | translate }}
</button>
